export const countryFromHost = (host = window.location.host) => {
    const envMatch = window.COUNTRY?.toLowerCase().match(/(ca|be|es|lu|br)/)
    const match = host.toLowerCase().match(/(ca|be|es|lu|br)\.(parkindigo|testindigo)\.com/)

    return (match && match[1]) || (envMatch && envMatch[0]) || 'ca'
}

export const countriesFromHost = () => {
    const country = countryFromHost()

    switch (country) {
        case 'fr':
        case 'be':
        case 'lu':
        case 'es':
            return 'FR,BE,LU,ES'
        case 'ca':
            return 'CA'
        case 'br':
        case 'br-neo':
            return 'BR'
        default:
            return 'UK'
    }
}

export const defaultLocaleFromHost = () => {
    const country = countryFromHost()

    switch (country) {
        case 'ca':
            return 'en-ca'
        case 'be':
            return 'nl-be'
        case 'es':
            return 'es-es'
        case 'lu':
            return 'fr-fr'
        case 'br':
        case 'pt':
            return 'pt-br'
        default:
            return 'en'
    }
}

export const languageFromPath = (pathname = window.location.pathname) => {
    const match = pathname.toLowerCase().match(/\/([a-z]{2})(?=\/|$)/)

    const country = (match && match[1]) || 'en'

    switch (country) {
        case 'en':
            return 'en-ca'
        case 'be':
            return 'nl-be'
        case 'es':
            return 'es-es'
        case 'lu':
        case 'fr':
            return 'fr-ca'
        case 'br':
        case 'pt':
            return 'pt-br'
        default:
            return 'en-ca'
    }
}

export const isHostCanada = countryFromHost() === 'ca'

export const isBrazilNeo = window.COUNTRY.toUpperCase() === 'BR-NEO'

export const getActiveLocale = languages => {
    // check if WP has returned list of languages
    if (Object.keys(languages).length) {
        // and return locale from the one that is 'current: true'
        return Object.values(languages)
            .find(lang => lang.current)
            .locale.toLowerCase()
    } else {
        // otherwise return a predefined default locale
        return defaultLocaleFromHost()
    }
}
